/* eslint-disable prettier/prettier */
import React from 'react';
import { Grid, Typography } from '@mui/material';

const PlayerGroupName = ({ playerGroupName }) => {
    if (!playerGroupName?.includes(' Vs ')) {
        return (
            <Typography
                variant="h4"
                sx={{
                    color: 'primary.text',
                    borderRadius: 1
                }}
            >
                {playerGroupName}
            </Typography>
        );
    }

    const parts = playerGroupName.split(/( Vs )/);

    const teamA = parts[0];
    const teamB = parts[2];
    const textStyle = {
        color: 'primary.text',
        borderRadius: 1,
        textAlign: 'center',
        whiteSpace: 'nowrap'
    };
    return (
        <Grid container>
            <Grid item xs={12}>
                <Typography variant="h4" sx={textStyle}>
                    {teamA}
                </Typography>
            </Grid>
            <Grid item xs={12}>
                <Typography variant="h5" sx={textStyle}>
                    vs
                </Typography>
            </Grid>
            <Grid item xs={12}>
                <Typography variant="h4" sx={textStyle}>
                    {teamB}
                </Typography>
            </Grid>
        </Grid>
    );
};

export default PlayerGroupName; 